import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M7 14.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14m2.475-9.912a.44.44 0 0 1 .312.13.443.443 0 0 1 0 .619L7.624 7.5l2.163 2.163a.44.44 0 1 1-.624.624L7 8.124l-2.163 2.163a.44.44 0 1 1-.624-.624L6.376 7.5 4.213 5.337a.44.44 0 1 1 .624-.624L7 6.876l2.163-2.159a.44.44 0 0 1 .312-.13",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }